import gql from 'graphql-tag';

export const SEND_PROVISIONAL_NOTIFICATIONS = gql`
  mutation {
  sendProvisionalToActualNotifications
  }
`;
